<div class="floating-window" cdkDrag>
  <mat-toolbar class="header-content">
    <div class="title">
      <ng-container *ngIf="icon">
        <mat-icon>{{icon}}</mat-icon>
      </ng-container>
      {{ title | translate}}
    </div>

    <lib-button (click)="handleCancel()" icon="close" color="none" textColor="muted"
      tooltip="{{'form.close'|translate}}">
    </lib-button>
  </mat-toolbar>

  <!-- Angle Input -->
  <div *ngIf="editedData().mapImageSrc" class="angleDiv">
    <label for="angleInput">
      <div class="label">
        <mat-icon>rotate_right</mat-icon>
        Angle:
      </div>
    </label>

    <lib-button (mousedown)="doDecrements()" (mouseleave)="stopDecrements()" (mouseup)="stopDecrements()" icon="remove"
      color="none" textColor="muted">
    </lib-button>

    <input matInput type="text" id="angleInput" [value]="angle" min="0" max="359" step="1" class="angleInput" #input
      (input)="onInputChange($event)" (focus)="onInputFocus($event)" (blur)="onInputBlur($event)">

    <lib-button (mousedown)="doIncrements()" (mouseup)="stopIncrements()" (mouseleave)="stopIncrements()" [disabled]=""
      icon="add" color="none" textColor="muted">
    </lib-button>
  </div>

  <!-- Opacity Slider -->
  <div *ngIf="editedData().mapImageSrc" class="opacityDiv">
    <label class="label">
      <mat-icon>opacity</mat-icon>
      Opacité:
    </label>

    <span class="opacityValue">{{ opacitySignal() }}%</span>

    <mat-slider min="0" max="100" step="1" class="opacitySlider">
      <input matSliderThumb [value]="opacitySignal()" (input)="onOpacityInput($event)"
        (change)="onOpacityCommit($event)">
    </mat-slider>
  </div>

  <div class="btn-group">
    <lib-button (click)="handleCancel()" color="muted" icon="undo" tooltip="{{'form.cancel'|translate}}">
    </lib-button>

    <lib-button (click)="save()" color="primary" icon="check" tooltip="{{'form.save'|translate}}">
    </lib-button>
  </div>
</div>